import type { ClikArtSortValue } from './types/clik-art-sort-value'

export const CLIKART_SORT_DEFAULT: ClikArtSortValue = 'newest'

export const CLIKART_SORT_OPTIONS: ReadonlyArray<{ value: ClikArtSortValue; label: string }> = [
  { value: 'newest', label: 'Newest first' },
  { value: 'oldest', label: 'Oldest first' },
  { value: 'az', label: 'A to Z' },
  { value: 'za', label: 'Z to A' },
]

function compareName(left: string, right: string): number {
  return left.localeCompare(right, undefined, { sensitivity: 'base', numeric: true })
}

/**
 * Reorders ClikArt results for the Sort control (WMPCM-10990). Newest/Oldest sort by
 * `jobYearStart` — the same field Backgrounds sorts by (`sortBackgrounds`), and the closest
 * upstream analog to a per-item timestamp a clikart has. An item missing `jobYearStart` (e.g. the
 * panel's own placeholder sample data) sorts as if it were 0, i.e. oldest.
 */
export function sortClikArt<T extends { name: string; jobYearStart?: number }>(
  items: T[],
  sort: ClikArtSortValue
): T[] {
  return items
    .map((item, index) => ({ item, index }))
    .sort((left, right) => {
      let cmp = 0

      if (sort === 'az' || sort === 'za') {
        cmp = compareName(left.item.name, right.item.name)
        if (sort === 'za') cmp = -cmp
      } else {
        const leftYear = left.item.jobYearStart ?? 0
        const rightYear = right.item.jobYearStart ?? 0

        cmp = sort === 'newest' ? rightYear - leftYear : leftYear - rightYear
      }

      if (cmp !== 0) return cmp

      return left.index - right.index
    })
    .map(({ item }) => item)
}
